import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Card from '~/components/cards/Card.vue';
import Stats from '~/components/reactions/Stats.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import Company from '~/components/profile/VacancyAuthor.vue';
import PanelButton from '~/components/panels/PanelButton.vue';
import Thumbnail from '~/components/thumbnails/Vacancy.vue';
import BackButton from '~/components/BackButton.vue';
import NavigationBar from '~/components/navigation/NavigationBar.vue';
import ShareButton from '~/components/share/ShareButton.vue';
import _numberFormat from '~/utilities/numberFormat.js';
export default {
  scrollToTop: true,
  components: {
    Card: Card,
    Stats: Stats,
    Company: Company,
    WebpPicture: WebpPicture,
    PanelButton: PanelButton,
    Thumbnail: Thumbnail,
    BackButton: BackButton,
    NavigationBar: NavigationBar,
    ShareButton: ShareButton,
    Panel: function Panel() {
      return import('~/components/panels/CasesPanel.vue');
    },
    ApplyPanel: function ApplyPanel() {
      return import("~/components/panels/VacancyApply.vue");
    },
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    CopyLink: function CopyLink() {
      return import('~/components/CopyLink.vue');
    },
    RejectedApplicationLetter: function RejectedApplicationLetter() {
      return import('~/components/panels/RejectedApplicationLetter');
    },
    Share: function Share() {
      return import('~/components/share/ShareDropdown.vue');
    }
  },
  head: function head() {
    var _this = this;
    var title = this.title;
    var desc = this.$t('vacancies.description');
    var url = "".concat(process.env.baseUrl, "/").concat(this.$route.path);
    var image = this.vacancy.thumbnail ? "".concat(this.$CDN, "/image/original/").concat(this.vacancy.thumbnail.name) : '';
    var meta = [{
      hid: 'title',
      name: "title",
      content: title
    }, {
      hid: "og:url",
      property: "og:url",
      content: url
    }, {
      hid: "og:title",
      property: "og:title",
      content: title
    }, {
      hid: "og:image",
      property: "og:image",
      content: image
    }, {
      hid: "twitter:url",
      name: "twitter:url",
      content: url
    }, {
      hid: "twitter:title",
      name: "twitter:title",
      content: title
    }, {
      hid: "twitter:image",
      name: "twitter:image",
      content: image
    }];
    if (desc) {
      meta.push({
        hid: 'description',
        name: 'description',
        content: desc
      });
      meta.push({
        hid: "og:description",
        property: "og:description",
        content: desc
      });
      meta.push({
        hid: "twitter:description",
        name: "twitter:description",
        content: desc
      });
    }
    var structuredData = {
      "@context": "https://schema.org/",
      "@type": "JobPosting",
      "title": this.jobTitle,
      "description": "<p>".concat(this.vacancy.summary, "</p>"),
      "identifier": {
        "@type": "PropertyValue",
        "name": this.vacancy.company.name,
        "value": this.vacancy.slug
      },
      "hiringOrganization": {
        "@type": "Organization",
        "name": this.vacancy.company.name,
        "sameAs": this.$link.protocol(this.vacancy.company.site),
        "logo": this.vacancy.company.logo
      }
    };
    if (this.vacancy.listingDate) {
      structuredData.datePosted = this.vacancy.listingDate.toString();
    }
    if (this.vacancy.expireAt) {
      structuredData.validThrough = this.vacancy.expireAt;
    }
    var salaryDisplay = this.vacancy.salaryDisplay;
    if (['salary', 'from', 'from-to', 'to'].includes(salaryDisplay)) {
      structuredData.baseSalary = {
        "@type": "MonetaryAmount",
        "currency": this.vacancy.currency.toUpperCase(),
        "value": {
          "@type": "QuantitativeValue",
          "unitText": "MONTH"
        }
      };
      if (salaryDisplay == 'salary') {
        structuredData.baseSalary.value.value = this.vacancy.salary;
      }
      if (['from', 'from-to'].includes(salaryDisplay)) {
        structuredData.baseSalary.value.minValue = this.vacancy.salaryMin;
      }
      if (['to', 'from-to'].includes(salaryDisplay)) {
        structuredData.baseSalary.value.value = this.vacancy.salaryMin;
      }
    }
    var employmentTypeMatrix = {
      "fulltime": "FULL_TIME",
      "partial": "PART_TIME",
      "project": "CONTRACTOR"
    };
    structuredData.employmentType = employmentTypeMatrix[this.vacancy.occupation];
    if (this.vacancy.thumbnail) {
      // Prevent errors when no thumbnail is set on draft pages

      structuredData.image = ["".concat(this.$CDN, "/image/small/").concat(this.vacancy.thumbnail.name), "".concat(this.$CDN, "/image/medium/").concat(this.vacancy.thumbnail.name), "".concat(this.$CDN, "/image/wide/").concat(this.vacancy.thumbnail.name)];
    }
    if (this.vacancy.format == 'remote') {
      structuredData.jobLocationType = "TELECOMMUTE";
      if (this.vacancy.countries) {
        structuredData.applicantLocationRequirements = this.vacancy.countries.map(function (code) {
          return {
            "@type": "Country",
            "name": code
          };
        });
      }
    } else if (this.vacancy.cities && this.vacancy.cities.length) {
      structuredData.jobLocation = {
        "@type": "Place",
        "address": this.vacancy.cities.map(function (o) {
          return {
            "@type": "PostalAddress",
            "addressLocality": o.name[_this.locale],
            "addressCountry": o.country ? o.country.toUpperCase() : 'UK'
          };
        })
      };
    }
    return {
      title: title,
      meta: meta,
      bodyAttrs: {
        class: 'gray-page'
      },
      script: [{
        type: 'application/ld+json',
        json: structuredData
      }]
    };
  },
  data: function data() {
    return {
      vacancy: {},
      followers: [],
      related: [],
      application: null,
      scrollPosition: 0,
      scrollingUp: true,
      navBarTitleVisible: false
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $axios, route, error, redirect, app, $appStore, id, preview, data, vacancy, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $axios = _ref.$axios, route = _ref.route, error = _ref.error, redirect = _ref.redirect, app = _ref.app, $appStore = _ref.$appStore;
            $appStore.$patch({
              activeApp: 'jobs'
            });
            id = route.params.slug;
            preview = route.params.preview;
            _context.next = 6;
            return $axios.$get("".concat($axios.defaults.baseURL, "/vacancy/get"), {
              params: {
                id: id,
                preview: preview
              }
            }).catch(function (e) {
              error({
                statusCode: 404,
                message: app.i18n.t('page.vacancy.404')
              });
            });
          case 6:
            data = _context.sent;
            vacancy = data && data.vacancy;
            if (vacancy) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", error({
              statusCode: 404,
              message: app.i18n.t('page.vacancy.404')
            }));
          case 10:
            if (!(!preview && vacancy && vacancy.slug && vacancy.slug != id && !vacancy.isTemp)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", redirect(app.localePath("/vacancy/".concat(vacancy.slug))));
          case 12:
            if (data.vacancy.listingDate) data.vacancy.listingDate = new Date(data.vacancy.listingDate);
            result = {
              vacancy: vacancy,
              application: data.application || null,
              followers: data.followers || [],
              related: data.related || []
            };
            return _context.abrupt("return", result);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  created: function created() {},
  mounted: function mounted() {
    // this.$socket.on('connect', this.connect);
    // this.$socket.on('update', this.update);

    // this.observe();
    // this.connect();

    // this.url = window.location.href;

    var text = this.$t('toast.previewTextModer', {
      name: this.vacancy.company.name
    });
    if (this.vacancy.status !== 'published') {
      this.$toastStore.add({
        id: "preview-".concat(this.vacancy.id),
        title: this.$t('toast.previewTitle'),
        text: text,
        icon: 'icon-ic-eye',
        autoClose: false
      });
    }
    window.addEventListener('scroll', this.trackScroll);
    this.trackScroll();
    this.observe();
  },
  computed: {
    jobTitle: function jobTitle() {
      return this.vacancy.title || this.$t('untitled');
    },
    title: function title() {
      return this.$t('title', {
        title: this.jobTitle,
        company: this.vacancy.company.name
      });
    },
    locale: function locale() {
      return this.$i18n.locale || 'uk';
    },
    canEdit: function canEdit() {
      var _this2 = this;
      if (!this.$auth.user) return false;
      if (this.$auth.user.role.fullAccess) return true;
      return this.$auth.user.moders && this.$auth.user.moders.some(function (o) {
        return o.approved && o.company.id == _this2.vacancy.company.id;
      });
    },
    appStore: function appStore() {
      return useAppStore();
    },
    backLink: function backLink() {
      var result = {
        label: 'backList',
        link: '/vacancies'
      };
      if (this.appStore.lastPage) {
        result.link = this.appStore.lastPage;
        if (!this.appStore.lastPage.match(/^(\/en)?\/vacancies/)) {
          result.label = 'back';
        }
      }
      return result;
    },
    format: function format() {
      var _this3 = this;
      var result = '';
      if (!this.vacancy.format) return result;
      this.vacancy.format.forEach(function (key, i) {
        var translation = _this3.$t("format.".concat(key));
        if (i == 0) {
          result = translation;
        } else {
          result = "".concat(result, ", ").concat(translation.toLowerCase());
        }
      });
      return result;
    }
  },
  watch: {
    scrollPosition: function scrollPosition(val, oldVal) {
      this.scrollingUp = oldVal > val || val <= 0;
    }
  },
  methods: {
    numberFormat: function numberFormat(number) {
      return _numberFormat(number, this.locale);
    },
    addApplication: function addApplication(application) {
      var _this4 = this;
      this.application = application;
      setTimeout(function () {
        return _this4.$cropContent();
      }, 100);
    },
    trackScroll: function trackScroll() {
      this.scrollPosition = window.scrollY;
    },
    apply: function apply() {
      if (this.$auth.user) {
        this.$modalityStore.toggleModal({
          type: 'drawer',
          name: 'vacancy-apply'
        });
      } else {
        this.$modalityStore.openModal({
          type: 'drawer',
          name: 'login',
          message: 'login.401.vacancyApply'
        });
      }
    },
    observe: function observe() {
      var _this5 = this;
      var topBarThreshold = 0.3;
      this.topBarObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= topBarThreshold;
          _this5.navBarTitleVisible = !visible;
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: topBarThreshold
      });
      var titleEl = document.querySelector('#title');
      if (titleEl) this.topBarObserver.observe(titleEl);
    },
    unobserve: function unobserve() {
      if (this.topBarObserver) this.topBarObserver.disconnect();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.trackScroll);
    this.unobserve();
  },
  destroyed: function destroyed() {
    this.$toastStore.remove("preview-".concat(this.vacancy.id));
  }
};